module.exports = __webpack_public_path__ + "static/media/bankNavLogo.52eb2245.svg";